import store from '@/store'
import {
  connectionService,
  RACE_TIMEOUT,
  NOTIFICATION_FETCH_URI,
  NOTIFICATION_CREATE_URI,
  NOTIFICATION_UPDATE_URI,
  NOTIFICATION_DELETE_URI
} from '@leapsight/styleguide'
import { i18n } from '@leapsight/portal'

export default {
  createNotification(notification) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [notification]
      const security = connectionService.createkwArgs()
      const kwArgs = {
        ...security
      }
      connection.session
        .call(NOTIFICATION_CREATE_URI, args, kwArgs, {})
        .then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
        .catch(err => {
          console.error(err)
        })
    })
  },

  getConnection() {
    return store.getters['auth/connection']
  },

  getNotification(_agentId) {
    return new Promise((resolve, reject) => {
      const connection = this.getConnection()
      const security = connectionService.createkwArgs()
      const args = [_agentId]
      const kwArgs = {
        ...security
      }
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, [])
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(NOTIFICATION_FETCH_URI, args, kwArgs, {})
          .then(response => {
            resolve(response.args[0])
          })
          .catch(error => {
            reject(error)
          })
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateNotification(notification) {
    const connection = this.getConnection()
    const security = connectionService.createkwArgs()
    const args = [notification.id, notification.data]
    const kwArgs = {
      ...security
    }
    const p1 = new Promise((resolve, reject) => {
      setTimeout(reject, RACE_TIMEOUT, [])
    })
    const p2 = new Promise((resolve, reject) => {
      connection.session
        .call(NOTIFICATION_UPDATE_URI, args, kwArgs, {})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })

    return Promise.race([p1, p2])
      .then(value => {
        return value
      })
      .catch(error => {
        return error
      })
  },

  deleteNotification(id) {
    const connection = this.getConnection()
    const security = connectionService.createkwArgs()
    const args = [id]
    const kwArgs = {
      ...security
    }
    const p1 = new Promise((resolve, reject) => {
      setTimeout(reject, RACE_TIMEOUT, [])
    })
    const p2 = new Promise((resolve, reject) => {
      connection.session
        .call(NOTIFICATION_DELETE_URI, args, kwArgs, {})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })

    return Promise.race([p1, p2])
      .then(value => {
        return value
      })
      .catch(error => {
        return error
      })
  },

  //ERRORS
  getErrorMessageByCode(code) {
    let strToReturn
    switch (code) {
      case 'com.magenta.error.constraint_violation':
        strToReturn = i18n.t(
          'fleet_management.agents.notifications.errors.constraint_violation'
        )
        break
      case 'com.magenta.error.unexpected_error':
        strToReturn = i18n.t(
          'fleet_management.agents.notifications.errors.unexpected_error'
        )
        break
      case 'wamp.error.no_such_procedure':
        strToReturn = i18n.t(
          'fleet_management.agents.notifications.errors.unexpected_error'
        )
        break

      default:
        strToReturn = i18n.t(
          'fleet_management.agents.notifications.errors.unexpected_error'
        )
        break
    }
    return strToReturn
  }
}
